export default __webpack_public_path__ + "static/media/TVOC_white.89be8916.png";